import * as CONST from "./actionTypes";

export const assetWithdraw = (data, callback) => ({
  type: CONST.POST_ASSET_WITHDRAW,
  payload: {data, callback},
});

export const assetWithdrawSuccess = (data) => ({
  type: CONST.ASSET_WITHDRAW_SUCCESS,
  payload: data,
});

export const assetWithdrawFail = (error) => ({
  type: CONST.ASSET_WITHDRAW_FAILED,
  payload: error,
});


export const assetWithdrawHistory = (data, callback) => ({
  type: CONST.GET_WITHDRAW_HISTORY,
  payload: {data, callback},
});

export const withdrawHistorySuccess = (data) => ({
  type: CONST.WITHDRAW_HISTORY_SUCCESS,
  payload: data,
});

export const withdrawHistoryFail = (error) => ({
  type: CONST.WITHDRAW_HISTORY_FAILED,
  payload: error,
});


export const transactionHistory = (data, callback) => ({
  type: CONST.TRANSACTION_HISTORY,
  payload: {data, callback},
});

export const transactionHistorySuccess = (data) => ({
  type: CONST.TRANSACTION_HISTORY_SUCCESS,
  payload: data,
});

export const transactionHistoryFail = (error) => ({
  type: CONST.TRANSACTION_HISTORY_FAILED,
  payload: error,
});
